import React, { useEffect, useState } from "react";
import "./AdminDashboard.css";

export default function AdminDashboard() {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all host codes
  const fetchCodes = async () => {
    try {
      const res = await fetch("/api/hostCodes");
      const data = await res.json();
      setCodes(data);
    } catch (err) {
      console.error("Error fetching host codes:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCodes();
  }, []);

  // Generate new host code
  const handleGenerate = async (plan = "free") => {
    try {
      const res = await fetch("/api/hostCodes/addHostCode", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ plan }),
      });
      const data = await res.json();
      if (data.code) {
        setCodes((prev) => [...prev, data]);
      }
    } catch (err) {
      console.error("Error generating host code:", err);
    }
  };

  // Delete host code
  const handleDelete = async (code) => {
    if (!window.confirm(`Delete host code ${code}?`)) return;
    try {
      const res = await fetch(`/api/hostCodes/${code}`, { method: "DELETE" });
      if (res.ok) {
        setCodes((prev) => prev.filter((c) => c.code !== code));
      }
    } catch (err) {
      console.error("Error deleting host code:", err);
    }
  };

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>

      <div className="controls">
        <button className="generate-btn" onClick={() => handleGenerate("free")}>
          Generate Free Code
        </button>
        <button className="generate-btn" onClick={() => handleGenerate("paid")}>
          Generate Paid Code
        </button>
      </div>

      {loading ? (
        <p>Loading codes...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Created</th>
              <th>Used At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {codes.length === 0 ? (
              <tr>
                <td colSpan="6">No codes available</td>
              </tr>
            ) : (
              codes.map((c) => (
                <tr key={c.code}>
                  <td className="code-cell">{c.code}</td>
                  <td>{c.plan}</td>
                  <td>{c.status}</td>
                  <td>{new Date(c.createdAt).toLocaleString()}</td>
                  <td>{c.usedAt ? new Date(c.usedAt).toLocaleString() : "-"}</td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(c.code)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
